import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import {
    FullViewContainer,
    FullViewSection,
    FullViewContent,
    CompactTitle,
    CompactSubtitle,
    CompactTextContainer,
    CompactText,
    CompactContentGrid,
    TextColumn,
    MediaColumn,
    CarouselContainer,
    CarouselSlide,
    CarouselImage,
    CarouselVideo,
    CarouselControls,
    CarouselButton,
    CarouselArrow,
    ServiceCtaButton,
    containerVariants,
    itemVariants,
    fadeInVariants
} from '../styles/PageStyles'
import { buildWhatsappUrl } from '../data/contact'
import video from '../assets/plantaVideo.mp4'
import plantaImage from '../assets/planta.jpg'


export default function PlantaClasificadora() {
    const { t } = useTranslation()
    const [currentSlide, setCurrentSlide] = useState(0)
    
    const slides = [
        {
            type: 'image',
            src: plantaImage,
            alt: 'Planta clasificadora de semillas Radixagro'
        },
        {
            type: 'video',
            src: video,
            alt: 'Video de la planta clasificadora'
        }
    ]

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length)
    }

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
    }

    const goToSlide = (index) => {
        setCurrentSlide(index)
    }

    return (
        <FullViewContainer>
            <FullViewSection>
                <FullViewContent>
                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <CompactTitle variants={itemVariants}>
                            {t("plantaTitle")}
                        </CompactTitle>
                        
                        <CompactSubtitle variants={itemVariants}>
                            Clasificamos y acondicionamos tu semilla con tecnología de primer nivel
                        </CompactSubtitle>

                        <CompactContentGrid variants={itemVariants}>
                            <TextColumn>
                                <CompactTextContainer>
                                    <CompactText>
                                        {t("plantaText")}
                                    </CompactText>
                                    <CompactText>
                                        Prestamos el servicio de clasificación y acondicionamiento
                                        de semilla a terceros: traés tu semilla y te la
                                        devolvemos limpia, clasificada y lista para sembrar, con
                                        la misma calidad y uniformidad que exigimos para la
                                        nuestra. Consultanos por volúmenes, especies y tiempos.
                                    </CompactText>
                                </CompactTextContainer>
                            </TextColumn>

                            <MediaColumn>
                                <CarouselContainer variants={fadeInVariants}>
                                    <AnimatePresence mode="wait">
                                        <CarouselSlide
                                            key={currentSlide}
                                            initial={{ opacity: 0, x: 300 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0, x: -300 }}
                                            transition={{ duration: 0.5 }}
                                        >
                                            {slides[currentSlide].type === 'image' ? (
                                                <CarouselImage 
                                                    src={slides[currentSlide].src}
                                                    alt={slides[currentSlide].alt}
                                                />
                                            ) : (
                                                <CarouselVideo 
                                                    controls 
                                                    muted
                                                    autoPlay
                                                    loop
                                                >
                                                    <source src={slides[currentSlide].src} type="video/mp4" />
                                                    Tu navegador no soporta el elemento de video.
                                                </CarouselVideo>
                                            )}
                                        </CarouselSlide>
                                    </AnimatePresence>

                                    <CarouselArrow 
                                        className="prev" 
                                        onClick={prevSlide}
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaChevronLeft />
                                    </CarouselArrow>

                                    <CarouselArrow 
                                        className="next" 
                                        onClick={nextSlide}
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <FaChevronRight />
                                    </CarouselArrow>

                                    <CarouselControls>
                                        {slides.map((_, index) => (
                                            <CarouselButton
                                                key={index}
                                                active={currentSlide === index}
                                                onClick={() => goToSlide(index)}
                                                whileHover={{ scale: 1.2 }}
                                                whileTap={{ scale: 0.9 }}
                                            />
                                        ))}
                                    </CarouselControls>
                                </CarouselContainer>
                            </MediaColumn>
                        </CompactContentGrid>

                        {/* Llamado a la acción */}
                        <motion.div variants={itemVariants} style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                            <ServiceCtaButton
                                href={buildWhatsappUrl('Hola, quiero clasificar mi semilla con Radixagro.')}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Quiero clasificar mi semilla con Radixagro
                            </ServiceCtaButton>
                        </motion.div>
                    </motion.div>
                </FullViewContent>
            </FullViewSection>
        </FullViewContainer>
    )
}
